// extracted by mini-css-extract-plugin
export default {"Wrapper":"LinkText_Wrapper__ApoPC","LinkText":"LinkText_LinkText__LAd4l","Underline":"LinkText_Underline__QlbHI"};